import * as Yup from "yup";

export const AddProductCategoryFormFieldName = {
  SUB_CATEGORY: "subCategory",
  "SUB_CATEGORY.NAME": (index) => `subCategory.${index}.name`,
  "SUB_CATEGORY.COUNTRY_ID": (index) => `subCategory.${index}.countryId`,
  NAME: "name",
};

export const validationSchema = () =>
  Yup.object().shape({
    [AddProductCategoryFormFieldName.NAME]: Yup.string().required(null),
    [AddProductCategoryFormFieldName.SUB_CATEGORY]: Yup.array().of(
      Yup.object().shape({
        name: Yup.string(),
        countryId: Yup.array(),
      })
    ),
  });
